/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';

import { Switch, Tooltip, useMediaQuery } from '@mui/material';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { PrimaryButton } from '@/components/Button/PrimaryButton';
import { Popup } from '@/components/Popup/Popup';
import { AirDropStatus } from '@/components/Shareaway/TokenCreation/AirDropStatus';
import { TooltipTitles } from '@/constants/tooltipTitles';
import { ISettingTabProps } from 'interfaces/PreviewScreen/previewScreen';
import EditFileIcon from 'public/assets/editFile.svg';
import eyeIcon from 'public/assets/eyeIcon.svg';

import FileAnalytics from './FileAnalytics';
import TokenLockedPopup from './TokenLockedPopup';

const SettingTab = ({
  file,
  setIsEditClicked,
  setActive,
  downloadable,
  setDownloadable,
}: ISettingTabProps) => {
  const [showAudience, setShowAudience] = useState<boolean>(false);
  const isMediaMax1025px = useMediaQuery('(max-width : 1025px)');

  const router = useRouter();
  const { fileId } = router.query;

  const handleEditClicked = () => {
    setIsEditClicked((pre: boolean) => !pre);
    if (setActive && isMediaMax1025px) {
      setActive('File');
    }
  };

  return (
    <div className="overflow-y-auto no-scrollbar">
      <div className="">
        <h4 className="font-semibold">Analytics</h4>
        <div className="w-full mt-2 h-full border border-[#DEDEDE] rounded-md relative overflow-hidden  ">
          <div className="flex justify-center">
            <FileAnalytics fileUuid={file.data.uuid} />
          </div>
        </div>
        {/* </Tooltip> */}
      </div>

      {file.data.currentPermission.edit && (
        <div className="mt-2">
          <span className="font-semibold mr-2">Downloadable</span>
          <Switch
            checked={downloadable}
            onChange={() => setDownloadable((pre: boolean) => !pre)}
          />
        </div>
      )}

      <div className="mt-2">
        <h4 className="font-semibold">File</h4>
        <div className="p-2 h-full">
          <button
            className="flex  w-full bg-yellow rounded-md justify-center px-8 py-6 items-center"
            onClick={handleEditClicked}
          >
            <img src={EditFileIcon.src} alt="Edit File" className="h-5 mr-2" />
            <h4 className="ml-1">Edit File</h4>
          </button>
        </div>
      </div>

      <div className="mt-2">
        <h4 className="font-semibold">Visibility</h4>
        <div className="p-2 h-full">
          {file.data.token ? (
            <Tooltip title={TooltipTitles.viewAudience} placement="top-start">
              <button
                className="flex  w-full bg-yellow rounded-md justify-center px-8 py-6 items-center"
                onClick={() => setShowAudience(true)}
              >
                <img src={eyeIcon.src} alt="View Audience" />
                <h4 className="ml-1">View Access Rules</h4>
              </button>
            </Tooltip>
          ) : (
            <Link href={`/files/${fileId}?setAccess=true`} passHref={true}>
              <Tooltip title={TooltipTitles.setAccess} placement="top-start">
                <button className="flex  w-full bg-yellow rounded-md justify-center px-8 py-6 items-center">
                  <h4 className="">Set Access Rules</h4>
                </button>
              </Tooltip>
            </Link>
          )}
        </div>
      </div>

      <Popup
        isOpen={showAudience}
        margin={isMediaMax1025px ? '90px 5%' : '70px auto'}
        width={isMediaMax1025px ? null : '650px'}
        closePopup={() => {}}
      >
        <div className="max-w-full box-border">
          {file.data.token ? (
            file.data.token.audienceUuid ? (
              <AirDropStatus
                AudUUID={file.data.token.audienceUuid}
                setShowAudience={setShowAudience}
                file={file}
              />
            ) : (
              <TokenLockedPopup file={file} setShowAudience={setShowAudience} />
            )
          ) : (
            <div className="flex flex-col justify-center items-center">
              <div className="text-lg font-semibold my-6">
                No Audience to show
              </div>
              <PrimaryButton onClick={() => setShowAudience(false)}>
                <span>Close</span>
              </PrimaryButton>
            </div>
          )}
        </div>
      </Popup>
    </div>
  );
};

export default SettingTab;
